export function DistrictVsCity() {
  const comparison = [
    {
      category: 'Jurisdiction',
      district: 'District of North Vancouver',
      city: 'City of North Vancouver',
      details: 'Two separate municipalities with different bylaws'
    },
    {
      category: 'Business License Required',
      district: 'Yes - Annual renewal',
      city: 'Yes - Annual renewal',
      details: 'Both require separate business licenses'
    },
    {
      category: 'Principal Residence',
      district: 'Must be owner-occupied',
      city: 'Must be owner-occupied',
      details: 'Owner must live on property during rental'
    },
    {
      category: 'Rental Duration',
      district: '30+ days minimum in most zones',
      city: 'Varies by zoning (some allow shorter)',
      details: 'City may permit shorter stays in certain areas'
    },
    {
      category: 'Parking Requirements',
      district: 'Must maintain required parking',
      city: 'Must maintain required parking',
      details: 'Cannot rent out parking spaces separately'
    },
    {
      category: 'Strata Restrictions',
      district: 'Must comply with strata bylaws',
      city: 'Must comply with strata bylaws',
      details: 'Many stratas prohibit STR entirely'
    },
    {
      category: 'Application Fee',
      district: '$250-$500 annually',
      city: '$200-$400 annually',
      details: 'Fees subject to change, verify current rates'
    },
    {
      category: 'Enforcement',
      district: 'Complaint-driven + proactive',
      city: 'Complaint-driven + proactive',
      details: 'Both monitor online platforms actively'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            District vs City: Key Differences
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            North Vancouver is divided into two separate municipalities. Understanding which jurisdiction your property falls under is essential for compliance.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-[#882629]">
                  <th className="px-6 py-5 text-left text-white font-semibold text-base">
                    Category
                  </th>
                  <th className="px-6 py-5 text-left text-white font-semibold text-base">
                    District of North Vancouver
                  </th>
                  <th className="px-6 py-5 text-left text-white font-semibold text-base">
                    City of North Vancouver
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparison.map((item, index) => (
                  <tr 
                    key={index}
                    className={`border-b border-[#F0F0F0] hover:bg-[#F0F0F0]/50 transition-colors ${
                      index % 2 === 0 ? 'bg-white' : 'bg-[#F0F0F0]/30'
                    }`}
                  >
                    <td className="px-6 py-5">
                      <div className="font-semibold text-[#505A5A] mb-1">
                        {item.category}
                      </div>
                      <div className="text-sm text-[#505A5A]/60">
                        {item.details}
                      </div>
                    </td>
                    <td className="px-6 py-5 text-[#505A5A]/80">
                      {item.district}
                    </td>
                    <td className="px-6 py-5 text-[#505A5A]/80">
                      {item.city}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-[#882629] rounded-xl mb-6">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#505A5A] mb-4">
              Check Your Municipality
            </h3>
            <p className="text-[#505A5A]/70 leading-relaxed mb-6">
              Not sure if you're in the District or City? Your property address determines jurisdiction. The District covers a larger geographic area including Lynn Valley, Deep Cove, and surrounding neighborhoods, while the City is the smaller urban core along the waterfront.
            </p>
            <a 
              href="https://www.dnv.org/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#882629] font-medium hover:underline cursor-pointer inline-flex items-center gap-2"
            >
              Visit District Website
              <i className="ri-external-link-line"></i>
            </a>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-[#882629] rounded-xl mb-6">
              <i className="ri-government-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#505A5A] mb-4">
              City Resources
            </h3>
            <p className="text-[#505A5A]/70 leading-relaxed mb-6">
              The City of North Vancouver has its own planning and licensing departments. If your property is in the City, you'll need to work with City staff for all licensing and compliance matters. Lower Lonsdale, Central Lonsdale, and parts of the waterfront fall under City jurisdiction.
            </p>
            <a 
              href="https://www.cnv.org/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#882629] font-medium hover:underline cursor-pointer inline-flex items-center gap-2"
            >
              Visit City Website
              <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
